import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Pets",
    keywords: [
      "petsmart",
      "petco",
      "pet supplies",
      "chewy",
      "vet ",
      "veterinary",
      "animal hospital",
      "pet clinic",
      "dog grooming",
      "pet grooming",
      "pet store",
      "pet food",
    ],
  },
  {
    category: "Education",
    keywords: [
      "tuition",
      "university",
      "college",
      "school payment",
      "student loan",
      "course fee",
      "udemy",
      "coursera",
      "khan academy",
      "textbook",
      "school supply",
      "pearson",
      "mcgraw hill",
      "park district",
      "cusd",
      "library",
    ],
  },
  {
    category: "Kid Activities",
    keywords: [
      "gymnastics",
      "swim lesson",
      "soccer league",
      "baseball league",
      "dance class",
      "music lesson",
      "karate",
      "martial arts",
      "daycare",
      "summer camp",
      "after school",
      "youth sports",
      "ultimate ninjas",
      "boys and girls club",
      "learning express",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "chewy", displayName: "Chewy" },
  { keyword: "petsmart", displayName: "PetSmart" },
  { keyword: "petco", displayName: "Petco" },
];
